module.exports = __webpack_public_path__ + "img/772967885.fb19a24d.jpg";